import SportPhotoCard from './SportPhotoCard';

export default function SportPhotoGrid({
  photos,
  viewMode = 'grid',
  cartPhotoIds = new Set(),
  addingToCart = {},
  favoriteIds = new Set(),
  onToggleFavorite,
  pricing = null,
  onAddToCart,
  onPhotoClick,
  t = {},
}) {
  const cardProps = (photo, idx, mode) => ({
    key: photo.id,
    photo,
    index: idx,
    inCart: cartPhotoIds.has(photo.id),
    isAdding: addingToCart[photo.id],
    isFavorite: favoriteIds.has(photo.id),
    onToggleFavorite,
    pricing,
    onAddToCart,
    onClick: () => onPhotoClick?.(idx),
    viewMode: mode,
    t,
  });

  if (viewMode === 'list') {
    return (
      <div className="flex flex-col gap-1">
        {photos.map((photo, idx) => (
          <SportPhotoCard {...cardProps(photo, idx, 'list')} />
        ))}
      </div>
    );
  }

  if (viewMode === 'masonry') {
    return (
      <div className="columns-1 sm:columns-2 md:columns-3 lg:columns-4 xl:columns-5 2xl:columns-6 gap-3 space-y-3">
        {photos.map((photo, idx) => (
          <SportPhotoCard {...cardProps(photo, idx, 'masonry')} />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3">
      {photos.map((photo, idx) => (
        <SportPhotoCard {...cardProps(photo, idx, 'grid')} />
      ))}
    </div>
  );
}
